export const FUMEI_IMAGE_CODES = {
  HERO_BG: 'fumei_hero_bg',
  QR: 'fumei_qr',
  FEATURE_1: 'fumei_feature_1',
  FEATURE_2: 'fumei_feature_2',
  FEATURE_3: 'fumei_feature_3',
  FEATURE_4: 'fumei_feature_4',
  GALLERY: 'fumei_gallery'
}

export const PRODUCT_PAGE_NAME = 'product'

export const PRODUCT_MODULE_IDS = {
  COLPOSCOPE: 'product_colposcope',
  TOUCHSCREEN: 'product_touchscreen_dermatoscope',
  PORTABLE: 'product_portable_dermatoscope',
  HANDHELD: 'product_handheld_dermatoscope',
  SPEECH_PORTABLE: 'product_speech_portable',
  SPEECH_SINGLE: 'product_speech_single',
  SPEECH_TABLET: 'product_speech_tablet',
  SPEECH_DUAL: 'product_speech_dual',
  SKIN_ANALYZER: 'product_skin_analyzer',
  VISIA: 'product_visia',
  COLONOSCOPY: 'product_colonoscopy',
  GASTROSCOPE: 'product_gastroscope',
  SMS_3000: 'product_sms3000',
  SMS_6000: 'product_sms6000'
}

/** 详情页产品标题 → module_id */
export function resolveProductModuleId(productTitle) {
  if (!productTitle || typeof productTitle !== 'string') return null
  const title = productTitle.trim()
  const lower = title.toLowerCase()

  if (title.includes('阴道')) return PRODUCT_MODULE_IDS.COLPOSCOPE
  if (title.includes('触屏式')) return PRODUCT_MODULE_IDS.TOUCHSCREEN
  if (title.includes('手持式')) return PRODUCT_MODULE_IDS.HANDHELD
  if (
    title.includes('便携式皮肤镜') ||
    (title.includes('便携式') && title.includes('皮肤') && !title.includes('言语'))
  ) {
    return PRODUCT_MODULE_IDS.PORTABLE
  }
  if (title.includes('言语认知便携式') || (title.includes('言语') && title.includes('便携'))) {
    return PRODUCT_MODULE_IDS.SPEECH_PORTABLE
  }
  if (title.includes('言语认知单屏幕') || (title.includes('言语') && title.includes('单屏'))) {
    return PRODUCT_MODULE_IDS.SPEECH_SINGLE
  }
  if (title.includes('言语认知平板式') || (title.includes('言语') && title.includes('平板'))) {
    return PRODUCT_MODULE_IDS.SPEECH_TABLET
  }
  if (title.includes('言语认知双屏') || (title.includes('言语') && title.includes('双屏'))) {
    return PRODUCT_MODULE_IDS.SPEECH_DUAL
  }
  if (lower.includes('visia')) return PRODUCT_MODULE_IDS.VISIA
  if (title.includes('面部')) return PRODUCT_MODULE_IDS.SKIN_ANALYZER
  if (title.includes('肠镜')) return PRODUCT_MODULE_IDS.COLONOSCOPY
  if (title.includes('胃镜')) return PRODUCT_MODULE_IDS.GASTROSCOPE
  if (title.includes('SMS-3000')) return PRODUCT_MODULE_IDS.SMS_3000
  if (title.includes('SMS-6000')) return PRODUCT_MODULE_IDS.SMS_6000
  return null
}
